import { CardFieldConfig } from './card-field-config.interface';
import { SearchConfig } from './search-config.interface';

/**
 * Main configuration for the generic card view component
 */
export interface CardViewConfig<T = unknown> {
  /**
   * Array of field configurations defining what and how to display
   */
  fields: CardFieldConfig<T>[];

  /**
   * The primary key field name for tracking items
   */
  primaryKey: keyof T | string;

  /**
   * Whether cards should be clickable
   * Default: false
   */
  clickable?: boolean;

  /**
   * Optional search configuration
   */
  searchConfig?: SearchConfig;
}
